export enum MetaDropdowns {
  CBSAoffice = 'CBSAOFFICECODE',
  CBSAofficeRegion = 'CBSAOFFICEREGION',
  CBSAsubOffice = 'SUBOFFICE',
  CBSAmodeTransport = 'MODEOFTRANSPORT',
  PortOfUnlading = 'PORTOFUNLADING',
  PortOfUnladingRegion = 'PORTOFUNLADINGREGION',
  WarehouseSubtype = 'SUBTYPECODE',
  WarehouseIn = 'WWAREHOUSEIN',
  WarehouseOut = 'WWAREHOUSEOUT',
  USportExit = 'USPORTOFEXITCODE',
  UnitOfMeasure = 'COMMCLASSUOMCODE',
  Currency = 'CURRENCYCODE',
  CountryOfOrigin = 'COUNTRYOFORIGINCODE',
  USState = 'COUNTRYOFORIGINCODES',
  PlaceOfExport = 'PLACEOFEXPORTCODE',
  PlaceOfExportState = 'PLACEOFEXPORTCODES',
  TariffCode = 'TARIFFCODE',
  ValueForDutyCode = 'LNVFDCODE',
  DestinationProvince = 'DESTPROVINCE',
  GstCode = 'GSTCODE',
  SurtaxSubject = 'SURTAXSUBJECT',
  SafeguardSubject = 'SAFEGUARDSUBJECT',
  SIMACode = 'SIMACODE',
  SIMAUnitOfMeasure = 'SIMAUOM',
  SIMAIncoterms = 'SIMAINCOTERMS',
  SIMAExportDeductionCurrency = 'SIMAEXPDEDUCTIONCURR',
  SIMAInvoicePriceCurrency = 'SIMAINVOICEPRICECURR',
}
